<div class="container-block">

  <ng-container *ngIf="!isViewAll">
    <app-position-in-config [elementChoosing]="blockChoosing" [device]="device"></app-position-in-config>

    <app-width-height-config   [device]="device"   [elementChoosing]="blockChoosing"  [elementType]="'block'" [width]="position['width']" [height]="position['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" >
      <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMenu.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="main-config">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="blockChoosing" [isBlock]="true">
          </app-hide-show-config>

          <!-- Set ảnh nền cho block blank -->
          <!-- Option màu nền cho frame -->
          <app-background-image-config [hasConfigGroup]="true" [configFieldName]="'block-chatbox'" [elementChoosing]="blockChoosing" [config]="config" [class]="class" [backgroundClass]="class['block-chatbox']"
            [backgroundConfig]="config['block-chatbox']" [id_object]="blockChoosing._id" [isBlock]="true"
            [device]="device">
          </app-background-image-config>
        </div>
      </li>
     
      
      <!-- Cấu hình vị trí-->
      <li nz-submenu nzTitle="{{'vi_tri_tren_trang' | translate}}" [(nzOpen)]="openMenu.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <nz-select [(ngModel)]="config.position.type" nzPlaceHolder="chon_loai_toa_do" (ngModelChange)="updateConfig()">
          <nz-option nzValue="top_left" nzLabel="{{'top_left' | translate}}"></nz-option>
          <nz-option nzValue="right_bottom" nzLabel="{{'right_bottom' | translate}}"></nz-option>
        </nz-select>
        <ng-container *ngIf="config.position.type == 'top_left'">
          <div nz-row style="margin: 16px 0;">
            <div nz-col nzSpan="24" class="d-flex justify-content-around align-items-center">
              {{'trai' | translate}}
              <nz-input-number [ngModel]="config.position.left  | vhnumber" (ngModelChange)="config.position.left = $event"
              (nzBlur)="updateConfig()" [nzMin]="0" [nzStep]="1"></nz-input-number>
             
          </div>
            <div nz-col nzSpan="24" class="d-flex justify-content-around align-items-center">
              {{'tren' | translate}}
                <nz-input-number [ngModel]="config.position.top  | vhnumber" (ngModelChange)="config.position.top = $event"
              (nzBlur)="updateConfig()" [nzMin]="0" [nzStep]="1"></nz-input-number>
            </div>
           
        </div>
        </ng-container>
        <ng-container *ngIf="config.position.type == 'right_bottom'">
          <div nz-row style="margin: 16px 0;">
            <div nz-col nzSpan="24" class="d-flex justify-content-around align-items-center">
              {{'phai' | translate}}
                <nz-input-number [ngModel]="config.position.right  | vhnumber" (ngModelChange)="config.position.right = $event"
              (nzBlur)="updateConfig()" [nzMin]="0" [nzStep]="1"></nz-input-number>
            </div>
            <div nz-col nzSpan="24" class="d-flex justify-content-around align-items-center">
              {{'duoi' | translate}}
                <nz-input-number [ngModel]="config.position.bottom  | vhnumber" (ngModelChange)="config.position.bottom = $event"
              (nzBlur)="updateConfig()" [nzMin]="0" [nzStep]="1"></nz-input-number>
            </div>
        </div>
        </ng-container>
        
        
      </li>
      
      <li nz-submenu nzTitle="{{'an_hien_thi_khi_cuon_trang' | translate}}" [(nzOpen)]="openMenu.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <nz-switch class="d-flex justify-content-center"
          [ngModel]="config.condition_show_hide?.enable" 
          (ngModelChange)="config.condition_show_hide.enable = $event; updateConfig()">
        </nz-switch>  

        <ng-container *ngIf="config.condition_show_hide?.enable">
          <div nz-col nzSpan="24" class="d-flex justify-content-between align-items-center mt-2">
            <span style="line-height: 1.5;">
              {{'thoi_gian_an_hien' | translate}} ({{'giay' | translate}})
            </span>
            <nz-input-number class="w-50"
              [ngModel]="config.condition_show_hide.duration | vhnumber" 
              (ngModelChange)="config.condition_show_hide.duration = $event + 's'"
              (nzBlur)="updateConfig()" [nzMin]="0.1" [nzStep]="0.01">
            </nz-input-number>
          </div>
          <div nz-col nzSpan="24" class="d-flex justify-content-between align-items-center mt-2">
            <span style="line-height: 1.5;">
              {{'truc_ngang_khi_an' | translate}} (%)
            </span>
            <nz-input-number class="w-50"
              [ngModel]="config.condition_show_hide.translateX_hidden | vhnumber" 
              (ngModelChange)="config.condition_show_hide.translateX_hidden = $event + '%'"
              (nzBlur)="updateConfig()" [nzMin]="0" [nzMax]="100" [nzStep]="1">
            </nz-input-number>
          </div>
          <div nz-col nzSpan="24" class="d-flex justify-content-between align-items-center mt-2">
            <span style="line-height: 1.5;">
              {{'truc_doc_khi_an' | translate}} (%)
            </span>
            <nz-input-number class="w-50"
              [ngModel]="config.condition_show_hide.translateY_hidden | vhnumber" 
              (ngModelChange)="config.condition_show_hide.translateY_hidden = $event + '%'"
              (nzBlur)="updateConfig()" [nzMin]="0" [nzMax]="100" [nzStep]="1">
            </nz-input-number>
          </div>
          <div nz-col nzSpan="24" class="d-flex justify-content-between align-items-center mt-2">
            <span style="line-height: 1.5;">
              {{'do_trong_suot_khi_an' | translate}}
            </span>
            <nz-input-number class="w-50"
              [ngModel]="config.condition_show_hide.opacity_hidden | vhnumber" 
              (ngModelChange)="config.condition_show_hide.opacity_hidden = $event"
              (nzBlur)="updateConfig()" [nzMin]="0" [nzMax]="1" [nzStep]="0.01">
            </nz-input-number>
          </div>
        </ng-container>
      </li>
      
      <!-- Cấu hình đường viền chung -->
      <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMenu.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['block-chatbox']"
          [id_object]="blockChoosing._id" [isBlock]="true" [elementChoosing]="blockChoosing">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border" style="float: right">
          <p class="m-0 title-border" (click)="openViewAll(stylesField[0])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
      <li nz-submenu nzTitle="{{'canh_le' | translate}}" nzIcon="" [(nzOpen)]="openMenu.menu3" (nzOpenChange)="openHandler('menu3')">
        <app-padding-config
          [objectChoosing]="blockChoosing"
          [device]="device"
          [class]="class"
          [classPadding]="class['block-chatbox']"
          [paddingConfigs]="[
            { type: 'top' },
            { type: 'bottom' },
            { type: 'left' },
            { type: 'right' }
          ]"  [isBlock]="true">
        </app-padding-config>

      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['block-chatbox']"
        [id_object]="blockChoosing._id" [isBlock]="true">
      </app-borders-radius-config>
    </div>
  </div>
</div>